module.exports = __webpack_public_path__ + "static/CFG_Artist_LincolnHeights-34f42cc0fde4834144951a116ee53f34.jpeg";